// ===============================================================
// ProBank — Delivery Gate
//
// fetchDeliveryGate(): asks the backend whether this user's
// outgoing transfers reach the recipient (subscription OR card).
//
// <DeliveryGateModal>: the warning shown BEFORE the PIN pad when
// the user has neither. Continue → PIN opens. Cancel → back.
// Buttons offer: subscribe to a plan, or get a ProBank card.
// ===============================================================

import React from "react";
import { useNavigate } from "react-router-dom";

const API_BASE = "https://alkebulanfkalertbackend.onrender.com/api";

export async function fetchDeliveryGate() {
  try {
    const token = localStorage.getItem("token");
    if (!token) return { canDeliver: true }; // fail-open, server still enforces

    const res = await fetch(`${API_BASE}/bank/delivery-status`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return { canDeliver: true };

    const data = await res.json();
    return { canDeliver: data.canDeliver !== false };
  } catch {
    return { canDeliver: true }; // network hiccup — never block the UI
  }
}

export function DeliveryGateModal({ open, onContinue, onCancel, brand }) {
  const navigate = useNavigate();
  if (!open) return null;

  const accent = brand?.accent || "#fbbf24";
  const accentText = brand?.accentText || "#111";
  const card = brand?.card || "#14171C";
  const line = brand?.line || "rgba(255,255,255,0.12)";

  return (
    <div
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)",
        display: "flex", alignItems: "flex-end", justifyContent: "center",
        zIndex: 120, padding: 16,
      }}
    >
      <div
        style={{
          background: card, border: `1px solid ${line}`, borderRadius: 16,
          padding: 24, maxWidth: 380, width: "100%",
        }}
      >
        <div style={{ textAlign: "center", fontSize: 34, marginBottom: 10 }}>⚠️</div>

        <div style={{ fontWeight: 800, fontSize: 17, textAlign: "center", marginBottom: 8 }}>
          Transaction Notice
        </div>

        <div style={{ color: "#9aa7b5", fontSize: 13, lineHeight: 1.65, textAlign: "center", marginBottom: 20 }}>
          This transaction will go through on your side, but it will{" "}
          <b style={{ color: "#f4f6f8" }}>not reflect in the recipient's account</b>{" "}
          until you subscribe to a plan or activate a ProBank card.
        </div>

        <button
          onClick={onContinue}
          style={{
            width: "100%", padding: "13px", borderRadius: 10, border: "none",
            background: accent, color: accentText, fontWeight: 700,
            fontSize: 14, cursor: "pointer", marginBottom: 10,
          }}
        >
          Continue Anyway
        </button>

        <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
          <button
            onClick={() => navigate("/subscription")}
            style={{
              flex: 1, padding: "11px", borderRadius: 10,
              border: `1px solid ${line}`, background: "none",
              color: "#f4f6f8", fontWeight: 600, fontSize: 12.5, cursor: "pointer",
            }}
          >
            Subscribe to a Plan
          </button>
          <button
            onClick={() => navigate("/cards")}
            style={{
              flex: 1, padding: "11px", borderRadius: 10,
              border: `1px solid ${line}`, background: "none",
              color: "#f4f6f8", fontWeight: 600, fontSize: 12.5, cursor: "pointer",
            }}
          >
            Get a ProBank Card
          </button>
        </div>

        <button
          onClick={onCancel}
          style={{
            width: "100%", padding: "11px", borderRadius: 10, border: "none",
            background: "none", color: "#7a93ab", fontWeight: 600,
            fontSize: 13, cursor: "pointer",
          }}
        >
          Cancel Transaction
        </button>
      </div>
    </div>
  );
}
